import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'zip-co-header-drop-down',
  templateUrl: './header-drop-down.component.html',
  styleUrls: ['./header-drop-down.component.scss'],
})
export class HeaderDropDownComponent {
  customerLogin: string;
  merchantLogin: string;

  constructor(private oAuthService: OAuthService, private location: Location) {
    this.customerLogin = `${environment.auth.customerLogin}`;
    this.merchantLogin = `${environment.auth.merchantLogin}`;
  }

  signIn() {
    this.oAuthService.initLoginFlow(this.location.path());
  }
}
